var _mask, _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTreasure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_11_122",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 10H16L13.8571 16H6C2.68629 16 0 18.6863 0 22V42C0 45.3137 2.68629 48 6 48H42C45.3137 48 48 45.3137 48 42V22C48 18.6863 45.3137 16 42 16H35.1429L33 10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10V7H13.8858L13.1748 8.99099L16 10ZM33 10L35.8252 8.99099L35.1142 7H33V10ZM13.8571 16V19H15.9713L16.6824 17.009L13.8571 16ZM35.1429 16L32.3176 17.009L33.0287 19H35.1429V16ZM16 13H33V7H16V13ZM16.6824 17.009L18.8252 11.009L13.1748 8.99099L11.0319 14.991L16.6824 17.009ZM6 19H13.8571V13H6V19ZM3 22C3 20.3431 4.34315 19 6 19V13C1.02944 13 -3 17.0294 -3 22H3ZM3 42V22H-3V42H3ZM6 45C4.34315 45 3 43.6569 3 42H-3C-3 46.9706 1.02944 51 6 51V45ZM42 45H6V51H42V45ZM45 42C45 43.6569 43.6569 45 42 45V51C46.9706 51 51 46.9706 51 42H45ZM45 22V42H51V22H45ZM42 19C43.6569 19 45 20.3431 45 22H51C51 17.0294 46.9706 13 42 13V19ZM35.1429 19H42V13H35.1429V19ZM30.1748 11.009L32.3176 17.009L37.9681 14.991L35.8252 8.99099L30.1748 11.009Z",
    fill: "#152C5B",
    mask: "url(#path-1-inside-1_11_122)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 32,
    r: 6.5,
    stroke: "#2B4CDE",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 22H33H41",
    stroke: "#152C5B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTreasure);
export default __webpack_public_path__ + "static/media/ic_treasure.e3119c08876c434941c3f3eec92772fb.svg";
export { ForwardRef as ReactComponent };